import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../Spinner';
import resx from '../../../utilities/resx';
import { RESX_REBLASTS } from '../../../Constants';
import ConfirmAlert from '../ConfirmAlert';


function CommentAttachmentPreview(props) {
	
	function handleRemovePreview() {
		ConfirmAlert({
			description: resx(RESX_REBLASTS, 'CONFIRM_REMOVING_ATTACHMENT'),
			confirmLabel: resx(RESX_REBLASTS, 'REBLASTS_REMOVE'),
			abortLabel: resx(RESX_REBLASTS, 'CANCEL_TEXT')
		}).then(() => {
			props.update(prevState => ({ ...prevState, commentsAttachmentsImage: null }));
		})
	}
	
	return (
		<React.Fragment>
			<Spinner
				size={'re-icon-xxl'}
				color={'re-icon-grey'}
				loading={props.data.isUploadingAttachment}
			/>
			{props.data.commentsAttachmentsImage &&
				<div className="attachment-upload-area">
					<div className="attachment-loading-area"></div>
				<div className={`re-attachment-display-preview-wrapper ${props.data.commentsAttachmentTypeId === "5" ? 're-attachment-pdf' : ''}`}>
					<img className="re-attachment-image" src={props.data.commentsAttachmentsImage}></img>
					<a className="re-icon re-icon-md re-icon-close re-remove-comment-attachment" title="Remove attachment" onClick={handleRemovePreview}></a>
				</div>
				</div>
			}
		</React.Fragment>
	);
};



CommentAttachmentPreview.propTypes = {
	data: PropTypes.object.isRequired,
	update: PropTypes.func.isRequired,
	commentsAttchmentsImage: PropTypes.string
};

export default CommentAttachmentPreview;
